import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import CompanyLuggageSetting from './CompanyLuggageSettings'

const MTPLMasterSetting = () => {
   const [searchParams] = useSearchParams()
  const [mtplMasterSettingOpt, setmtplMasterSettingOpt] = useState(Number(searchParams.get('id')) || '')
  useEffect(() => {
    setmtplMasterSettingOpt(Number(searchParams.get('id')))
  }, [searchParams])
  let acountingType
  switch (mtplMasterSettingOpt) {
    case 1: {
      acountingType = <CompanyLuggageSetting />
      break
    }
  }
  return acountingType
}

export default MTPLMasterSetting